export default [
  {
    path: '/Help',
    component: () => import('@/views/Help/List'),
    name: 'Help',
    meta: {
      title: '帮助中心列表',
      noCache: true,
      affix: true
    }
  },

  {
    path: '/Help/Detail/:id',
    component: () => import('@/views/Help/Detail'),
    name: 'HelpDetail',
    meta: {
      title: '帮助中心详情',
      noCache: true,
      affix: true
    }
  }
]
